import { createSelector } from "reselect";
import { formatCreationDate } from "~/utils/date";
import { descSortCompare, sortCompare } from "~/utils/utils";
import { getDiscussionSortByProjectIdConfigOption, getPersonalizedDateFormat } from "./selector.configOptions";

export const getAllDiscussions = (state) => state.discussions;
export const getDiscussionById = (state, id) => getAllDiscussions(state)[id];

const getDiscussionsArray = createSelector(getAllDiscussions, (discussions) => Object.values(discussions));

const getActiveProjectDiscussions = createSelector(
  getDiscussionsArray,
  (state, projectId) => projectId,
  (discussions, projectId) => {
    return discussions.filter((discussion) => {
      return discussion.project_id === projectId && !discussion.is_trashed;
    });
  }
);

export const sortDiscussionsForScreen = (discussions, sortConfig) => {
  let sorted = [];
  if (sortConfig.sort === "created") {
    sorted = discussions.sort((a, b) => {
      if (sortConfig.order === "desc") {
        return descSortCompare(a.created_on, b.created_on);
      }
      return sortCompare(a.created_on, b.created_on);
    });
  } else if (sortConfig.sort === "name") {
    sorted = discussions.sort((a, b) => {
      let dir = 1;
      if (sortConfig.order === "desc") {
        dir = -1;
      }
      return (
        dir *
        a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: "base",
        })
      );
    });
  } else {
    sorted = discussions.sort((a, b) => {
      if (sortConfig.order === "desc") {
        return descSortCompare(a.updated_on, b.updated_on);
      }
      return sortCompare(a.updated_on, b.updated_on);
    });
  }
  return sorted;
};
export const getDiscussionsGroupCollection = createSelector(
  getActiveProjectDiscussions,
  getDiscussionSortByProjectIdConfigOption,
  getPersonalizedDateFormat,
  (discussions, sortConfig, format) => {
    const sorted = sortDiscussionsForScreen(discussions, sortConfig);
    const collection = { "#pinned": [], "#other": [] };
    const result = sorted.reduce((prev, next) => {
      let key;
      if (next.is_pinned) {
        key = "#pinned";
      } else if (sortConfig.sort === "name") {
        key = "#other";
      } else if (sortConfig.sort === "updated") {
        key = formatCreationDate(next.updated_on, format, false);
      } else {
        key = formatCreationDate(next.created_on, format, false);
      }
      if (!prev[key]) {
        prev[key] = [];
      }
      prev[key].push(next.id);
      return prev;
    }, collection);
    return Object.keys(result).reduce((prev, next) => {
      if (result[next].length) {
        prev[next] = result[next];
      }
      return prev;
    }, {});
  }
);
